import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { HeaderUserItem } from "codekit";

import { getIsAdmin, getIsOtherUser, setEntrarcuAbierto } from "../../../libs/redux/slices/authSlice/authSlice";

/**
 * "Entrar como usuario" (Diego 2026-09-14): ítem del menú del usuario, solo para
 * administradores que no están ya dentro de otro usuario. Abre la ventana de
 * elección (vive en Entrarcub, fuera del menú, para que no se desmonte al cerrarlo).
 * @author Diego Serrano <diego.serrano@repremundo.com.co>
 * @since 2026-09-14
 */
const Entrarcu = () => {
  const dispatch = useDispatch();
  const isAdmin = useSelector(getIsAdmin);
  const isOtherUser = useSelector(getIsOtherUser);
  if (!isAdmin || isOtherUser) {
    return null;
  }
  return (
    <HeaderUserItem icon="user-change" onClick={() => dispatch(setEntrarcuAbierto(true))}>
      Entrar como usuario
    </HeaderUserItem>
  );
};

export default Entrarcu;
